import {
    transformToPixels,
    useHeaderScroll,
    setCookie,
    getCookie,
} from "../common/helpers";
import { useConstructorPage } from "../../pages/nsConstructorPage";

import { HEADER_GAP } from "../constants";

const ANNOUNCEMENT_HIDDEN_KEY = "hideAnnouncement";

export const useHeader = () => {
    const $header = document.querySelector(".js-ns-header");
    const $announcement = document.querySelector(".js-ns-header-announcement");
    const $getInTouchButton = document.querySelector(
        ".js-ns-header-get-in-touch"
    );
    const $heroGetInTouchButton = document.querySelector(
        ".js-hero-get-in-touch"
    );

    const { handleHeaderScroll } = useHeaderScroll($header);
    const { transformContentPadding } = useConstructorPage();

    let announcementInitiated = false;
    let isInitiated = false;

    const handleHeaderEnter = () => {
        $announcement.classList.add("ns-header-announcement--z");
    };

    const handleHeaderLeave = () => {
        $announcement.classList.remove("ns-header-announcement--z");
    };

    const hideAnnouncement = () => {
        const $header = document.querySelector(".js-ns-header");

        $announcement.classList.add("ns-header-announcement--hidden");

        $header.style.paddingTop = transformToPixels(HEADER_GAP);

        transformContentPadding();

        setCookie(ANNOUNCEMENT_HIDDEN_KEY, 1, 0);
    };

    const showGetInTouchButton = () => {
        $getInTouchButton.classList.add("active");
        $getInTouchButton.removeAttribute("inert");
    };

    const hideGetInTouchButton = () => {
        $getInTouchButton.classList.remove("active");
        $getInTouchButton.setAttribute("inert", "true");
    };

    const handleGetInTouchScroll = () => {
        const offsetY =
            $heroGetInTouchButton.getBoundingClientRect().top + window.scrollY;
        const height = $heroGetInTouchButton.clientHeight;
        const scrollTop = window.scrollY;

        if (scrollTop >= offsetY + height) {
            showGetInTouchButton();

            return;
        }

        hideGetInTouchButton();
    };

    const initGetInTouchButton = () => {
        if (!$heroGetInTouchButton) {
            showGetInTouchButton();

            return;
        }

        window.addEventListener("scroll", handleGetInTouchScroll);
    };

    const initAnnouncement = () => {
        if (!$announcement) {
            return;
        }

        if (announcementInitiated === true) {
            return;
        }

        const isHidden = getCookie(ANNOUNCEMENT_HIDDEN_KEY);

        if (isHidden) {
            hideAnnouncement();

            return;
        }

        $announcement.classList.remove("ns-header-announcement--hidden");

        const height = $announcement.clientHeight;

        $header.style.paddingTop = transformToPixels(
            Number(height) + HEADER_GAP * 2
        );

        const $headerContent = $header.querySelector(".ns-header__content");
        const $close = $announcement.querySelector(
            ".js-ns-header-announcement-close"
        );

        $headerContent.addEventListener("mouseenter", handleHeaderEnter);
        $headerContent.addEventListener("mouseleave", handleHeaderLeave);

        $close.addEventListener("click", hideAnnouncement);

        announcementInitiated = true;
    };

    const init = () => {
        if (!$header || isInitiated === true) {
            return;
        }

        initAnnouncement();
        initGetInTouchButton();
        handleHeaderScroll();

        isInitiated = true;
    };

    const initHeader = () => {
        document.addEventListener("DOMContentLoaded", init);
        window.addEventListener("resize", init);
        window.addEventListener("scroll", handleHeaderScroll);
    };

    return {
        initHeader,
    };
};
